export const LEAGUE_FIXTURES_COPY = {
  LOADING: 'Loading fixtures…',
  EMPTY: 'No fixtures available for this league.',
  LOAD_MORE: 'Show more fixtures',
  LOADING_MORE: 'Loading…',
} as const;

export const LEAGUE_FIXTURES_TEST_IDS = {
  loadMore: 'league-fixtures-load-more',
  banner: 'league-fixture-banner',
} as const;
